var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotifications)?_c('b-nav-item',{attrs:{"right":"","to":"/list/notification"}},[_c('Notification',{key:_vm.$route.path})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }